import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
import { TrustStrip } from './TrustStrip';
import { BRAND, HERO_BODY, HERO_HEADLINE_BOTTOM, HERO_HEADLINE_TOP, HERO_KICKER, HERO_LABEL_SUB, HERO_SUB, MAIN_MOCKUP, MOCKUP_ALT, PRODUCT, heroBenefits, heroFlow } from '../data/poolContent';
export function Hero() {
  return <header className="w-full bg-abyss-950" data-id="element-155" data-mp="1285ztvqq06q0">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 pt-5" data-id="element-156" data-mp="1274nlnxyxe6p">
        <p className="font-display text-lg font-bold tracking-[0.2em] text-frost-50" data-id="element-157" data-mp="x8b7rov7lb3d">{BRAND}</p>
        <p className="hidden text-[10px] font-medium uppercase tracking-[0.16em] text-muted sm:block" data-id="element-158" data-mp="sde3ev8vjpwt">
          100% Digital · Instant Access
        </p>
      </div>

      <div className="mx-auto flex max-w-6xl flex-col px-5 pb-10 pt-8 text-center lg:grid lg:grid-cols-[1.05fr_1fr] lg:grid-rows-[auto_auto] lg:items-center lg:gap-x-12 lg:pb-16 lg:pt-10 lg:text-left" data-id="element-159" data-mp="3d2bjjokooxv0">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-160" data-mp="3j9u06x1wdkkr">
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-aqua sm:text-[11px]" data-id="element-161" data-mp="3o85a17s6zv2z">
            {HERO_KICKER}
          </p>
          <h1 className="mx-auto mt-4 max-w-xl font-display text-[2.4rem] font-bold uppercase leading-[0.95] text-frost-50 sm:text-[3.2rem] lg:mx-0 lg:text-[3.9rem]" data-id="element-162" data-mp="39a362wh917l7">
            {HERO_HEADLINE_TOP}
            <span className="mt-1 block text-pool-light" data-id="element-163" data-mp="30gq4l654cxni">{HERO_HEADLINE_BOTTOM}</span>
          </h1>

          <p className="mx-auto mt-5 max-w-lg text-[14px] font-medium leading-relaxed text-frost-100 sm:text-[15px] lg:mx-0" data-id="element-164" data-mp="35a2fyeksf7yb">
            {HERO_SUB}
          </p>
          <p className="mx-auto mt-3 max-w-lg text-[13.5px] leading-relaxed text-body sm:text-[14.5px] lg:mx-0" data-id="element-165" data-mp="2vi56bc9fgo1p">
            {HERO_BODY}
          </p>

          <ol className="mt-5 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1.5 lg:justify-start" aria-label="How the guide works" data-id="element-166" data-mp="2hlj8205ngx6r">
            {heroFlow.map((step, i) => <li key={step} className="flex items-center gap-2.5" data-id="element-167" data-mp="nbl2il2gggag" data-mpi={i}>
                <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-aqua sm:text-[12px]" data-id="element-168" data-mp="n98epra0nbph">
                  {step}
                </span>
                {i < heroFlow.length - 1 && <span className="text-pool/60" aria-hidden="true" data-id="element-169" data-mp="dbaqh3s5pewv">
                    →
                  </span>}
              </li>)}
          </ol>
        </div>

        <figure className="mx-auto my-8 w-full max-w-md sm:max-w-lg lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:my-0 lg:max-w-none" data-id="element-170" data-mp="15zzubakljycb">
          <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="w-full object-contain" width={1199} height={1312} data-id="element-171" data-mp="x1nxurx1u6by" />
          <figcaption className="mt-3 text-center" data-id="element-172" data-mp="3hrlmup2hqjc5">
            <span className="block font-display text-xl font-bold uppercase tracking-[0.06em] text-frost-50" data-id="element-173" data-mp="3hpsft8nytx3m">
              {PRODUCT}
            </span>
            <span className="mt-0.5 block text-[11px] font-medium uppercase tracking-[0.14em] text-muted" data-id="element-174" data-mp="21aej5hv4snb5">
              {HERO_LABEL_SUB}
            </span>
          </figcaption>
        </figure>

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-175" data-mp="2b0fy9k5iavdx">
          <ul className="mx-auto grid max-w-lg gap-x-5 gap-y-2 text-left sm:grid-cols-2 lg:mx-0 lg:mt-7" data-id="element-176" data-mp="2b2sjq7ah3nvq">
            {heroBenefits.map(b => <li key={b} className="flex items-start gap-2" data-id="element-177" data-mp="2ky40ev5fz564">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aqua" strokeWidth={2.5} aria-hidden="true" data-id="element-178" data-mp="2p0h7pnzu7b50" />
                <span className="text-[13.5px] leading-snug text-frost-100" data-id="element-179" data-mp="2txhczwov49v2">{b}</span>
              </li>)}
          </ul>

          <PriceBlock align="start" size="md" className="mt-7" data-id="element-180" data-mp="zlausdxjwst9" />

          <div className="mt-5 flex justify-center lg:justify-start" data-id="element-181" data-mp="znn8ug06uj11">
            <CtaButton size="lg" data-id="element-182" data-mp="4a2xptbp3q3u" />
          </div>
          <TrustStrip variant="full" className="mt-4 lg:justify-start" data-id="element-183" data-mp="3vhp25o68nwlr" />
        </div>
      </div>
    </header>;
}